import { setTelemetryUser } from "@socotec.io/socio-vue-components";
import { agencyClient } from "@/api/userManagementSetup";

let lastTelemetryUserKey = null;

const enrichWithAgencyGroup = async (oidcUser) => {
  const agencyCode = oidcUser.profile.codeSite;
  if (!agencyCode) return oidcUser;

  let agency = null;
  try {
    agency = await agencyClient.retrieveByCode({ code: agencyCode });
  } catch (err) {
    console.warn("[telemetry] Failed to retrieve agency by code:", err);
  }

  const agencyGroup = agency?.agencyGroup || {};
  return {
    ...oidcUser,
    profile: {
      ...oidcUser.profile,
      agencyGroup: agencyGroup.name,
      agencyGroupCode: agencyGroup.code,
    },
  };
};

export const setRapsotecTelemetryUser = async (oidcUser, userProfile, enableTelemetry) => {
  if (!oidcUser?.profile || !userProfile?.email) return;

  const telemetryUserKey = [userProfile.usermanagement_uuid, oidcUser.profile.codeSite || ""].join(
    ":",
  );

  if (telemetryUserKey === lastTelemetryUserKey) return;

  const telemetryUser = await enrichWithAgencyGroup(oidcUser);
  setTelemetryUser(telemetryUser, enableTelemetry);
  lastTelemetryUserKey = telemetryUserKey;
};
